// DTM
import React, { Component } from "react";
import styled from "styled-components";
import { store } from "../redux/store";
import { setPage } from "../redux/actions/page";

export const FlatBody = styled.div`
  p {
    padding: 0;
    margin: 0;
  }
`;

const Body = styled.div`
  a {
    font-size: 0.8em;
    text-decoration: none;

    font-family: Lato;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1px;
    color: #3949ab;

    text-transform: uppercase;
  }
  a:hover {
    color: #3949ab;
    text-decoration: underline;
  }
  a.video {
    color: #ff5368;
    position: relative;
    padding: 0 0 3px 30px;
    height: 17px;
    display: inline-block;
  }
  a.video::before {
    content: "";
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDIwIDE5Ij4gICAgPHBhdGggZmlsbD0iI0ZGNTM2OCIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTQuMzY1IDE3LjY2NWMyLjc4NC0xLjY2OSA0LjY1NS00LjY5NCA0LjY1NS04LjE2NSAwLTUuMjI4LTQuMjc2LTkuNS05LjUxLTkuNVMwIDQuMjcyIDAgOS41IDQuMjc2IDE5IDkuNTEgMTlIMjB2LTEuMzM1aC01LjYzNXptLTMuMzQtMTMuMDM3Yy45MTMtLjkxMyAyLjQyNy0uOTEzIDMuMzYzIDAgLjQ0NS40NjcuNjkgMS4wNDUuNjkgMS42OWEyLjM3IDIuMzcgMCAwIDEtLjY5IDEuNjkxIDIuMzk1IDIuMzk1IDAgMCAxLTMuMzY0IDAgMi40MDggMi40MDggMCAwIDEtLjY5LTEuNjljMC0uNjQ2LjI0NS0xLjI0Ni42OS0xLjY5MXptLTYuMzcgMGEyLjM2OCAyLjM2OCAwIDAgMSAzLjM2MyAwYy40NDUuNDY3LjY5IDEuMDQ1LjY5IDEuNjlhMi4zNyAyLjM3IDAgMCAxLS42OSAxLjY5MSAyLjM5NSAyLjM5NSAwIDAgMS0xLjY5My42OSAyLjM2MSAyLjM2MSAwIDAgMS0xLjY3LS42OSAyLjQwOCAyLjQwOCAwIDAgMS0uNjktMS42OWMwLS42NDYuMjQ0LTEuMjQ2LjY5LTEuNjkxem0zLjM2MyA5Ljc0NGEyLjM5NSAyLjM5NSAwIDAgMS0xLjY5My42OSAyLjM1NyAyLjM1NyAwIDAgMS0xLjY5Mi0uNjkgMi4zNjIgMi4zNjIgMCAwIDEgMC0zLjM2IDIuMzk0IDIuMzk0IDAgMCAxIDMuMzg1IDAgMi4zNjIgMi4zNjIgMCAwIDEgMCAzLjM2em0xLjQ5Mi0zLjc2Yy0uNjI0IDAtMS4xMTQtLjQ5LTEuMTE0LTEuMTEyIDAtLjYyMy40OS0xLjExMiAxLjExNC0xLjExMi42MjQgMCAxLjExNC40OSAxLjExNCAxLjExMiAwIC42MjMtLjQ5IDEuMTEyLTEuMTE0IDEuMTEyem0xLjUxNCAzLjc2YTIuMzYyIDIuMzYyIDAgMCAxIDAtMy4zNmMuOTE0LS45MzQgMi40MjgtLjkzNCAzLjM4NiAwYTIuMzYyIDIuMzYyIDAgMCAxIDAgMy4zNiAyLjM5NSAyLjM5NSAwIDAgMS0xLjY5My42OSAyLjM1NyAyLjM1NyAwIDAgMS0xLjY5My0uNjl6Ii8+PC9zdmc+);

    position: absolute;
    bottom: 0;
    left: 0;

    height: 19px;
    width: 20px;
  }
  a.video::after {
    content: "";

    width: calc(100% - 30px);
    position: absolute;
    left: 30px;
    bottom: 0;

    border-bottom: 1px solid #ff5368;
  }
  a.video:hover {
    text-decoration: none;
  }
  @media (max-width: 700px) {
    a {
      font-size: 1em;
    }
  }
`;

class ArticleAbstract extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  image = main => {
    let url = this.imageUrl(main);
    if (url) {
      return { backgroundImage: 'url("' + url + '")' };
    }
    return {};
  };
  imageUrl = main => {
    if (this.props.content && this.props.content.images) {
      if (this.props.content.images.intro && !main) {
        return this.props.content.images.intro.url.replace(/^http:/, "");
      }
      if (this.props.content.images.main) {
        return this.props.content.images.main.url.replace(/^http:/, "");
      }
    }
    return false;
  };
  title = () => {
    if (this.props.content && this.props.content.title) {
      return this.props.content.title;
    }
    return "";
  };
  meta = (child, fallback) => {
    if (this.props.content.template && this.props.content.template.values) {
      if (child) {
        if (this.props.content.template.values[child]) {
          return this.props.content.template.values[child];
        }
        return fallback;
      }
      return this.props.content.template.values;
    }
    return fallback || {};
  };
  body = () => {
    if (this.props.content && this.props.content.body) {
      return (
        <Body dangerouslySetInnerHTML={{ __html: this.props.content.body }} />
      );
    }
    return <Body />;
  };
  link = style =>
    this.props.content &&
    this.props.content.template &&
    this.props.content.template.values &&
    this.props.content.template.values.link
      ? {
          onClick: () => {
            if (this.props.content.template.values.link.startsWith("http")) {
              window.open(this.props.content.template.values.link, "_blank");
            } else {
              store.dispatch(setPage(this.props.content.template.values.link));
            }
          },
          style: { cursor: "pointer", ...(style || {}) }
        }
      : {};
  // render() {
  //   return <></>
  // }
}

export default ArticleAbstract;



// WEBPACK FOOTER //
// ./src/components/ArticleAbstract.js